var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfettiDialog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "328px",
    height: "53px",
    viewBox: "0 0 328 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Entertainment",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Entertainment---Premium-Content-1-Copy-3",
    transform: "translate(-574.000000, -355.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(542.000000, 341.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(32.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#21445E",
    points: "82 11.6116957 94.0458854 5 94.0458854 16.9817756"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    fill: "#21445E",
    points: "254 35.6116957 266.045885 29 266.045885 40.9817756"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#3AACE2",
    points: "121.172413 20 117 41.0011332 124.938175 37.2978108"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2-Copy",
    fill: "#58EDB9",
    points: "310.172413 4.52970994e-13 306 21.0011332 313.938175 17.2978108"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "#58EDB9",
    points: "10.5107721 14 -3.55271368e-15 19.193593 20.4291261 25.9988668"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3-Copy",
    fill: "#58EDB9",
    points: "199.510772 31 189 36.193593 209.429126 42.9988668"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#3AACE2",
    points: "221 7 221 14.2625854 229.681123 10.6312927"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4-Copy",
    fill: "#3AACE2",
    points: "319 45 319 52.2625854 327.681123 48.6312927"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    fill: "#58EDB9",
    points: "58 38 58 43.8650883 64.0229427 40.9325442"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiDialog);
export default __webpack_public_path__ + "static/media/confetti_dialog.7af87764d9497e2361e6625cc3dbb34f.svg";
export { ForwardRef as ReactComponent };